<template>
  <van-icon v-if="checked" name="checked" size="var(--fs-ex1)" color="var(--c1)" />
  <van-icon v-else name="circle" size="var(--fs-ex1)" color="var(--g5)" />
</template>

<script>
export default {
  name: 'side-icon-select',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>